import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token = localStorage.getItem("jwt");
  headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    "Grpc-Metadata-Authorization": "Bearer " + this.token
  });
 //constructor
 constructor(private http: HttpClient) {

}

usuarioActual = {
  id: null,
  login: null,
  tipo: null
}

loginuser(login: string, clave: string): Observable<any> {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/usuario/' + login + '/' + clave).pipe(map(result => result));
}

loginAgua(login): Observable<any> {
  return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/MarsedEpmaps/Svc/Administracion.svc/UsuarioLogin', login).pipe(map(result => result));
}

//setUser(user): void {
//  let user_string = JSON.stringify(user);
//  localStorage.setItem("currentUser", user_string);
//}
setToken(token): void {
  localStorage.setItem("accessToken", token);
  //console.log('este' + token);
}

getToken() {
  return localStorage.getItem("accessToken");
}
getTokenJwt() {
  var token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlfa2V5X2lkIjoiZTQ2MzNjZGEtYzUyYy00N2YxLTk3YTMtY2MxN2M0OWVkOTY4IiwiYXVkIjoiYXMiLCJpc3MiOiJhcyIsIm5iZiI6MTYzNjY2MzU3Nywic3ViIjoiYXBpX2tleSJ9.mISS0KyE89bSiVuSDf48T6RQnRJnLTDwy7746qDqfXM";
  return token;
}
setTokenJwt(tokenJwt): void {
  sessionStorage.setItem("jwt", tokenJwt);
  console.log('este jwt ' + tokenJwt);
}

setUsuarioActual(usuarioActual): void {
  this.usuarioActual.id = usuarioActual.id;
  this.usuarioActual.login = usuarioActual.login;
  this.usuarioActual.tipo = usuarioActual.tipo;
}
getUsuarioActual(){
  return this.usuarioActual;
}
//getCurrentUser() {
//  //let user_string = localStorage.getItem('currentUser');
//  if (isNullOrUndefined(user_string)) {
//    let user = JSON.parse(user_string);
//    return user;
//  } else {
//    return null;
//  }

 //chirp
 loginChirp(login): Observable<any> {
  return this.http.post('https://corp-190-12-6-203.uio.puntonet.ec:8080/api/internal/login', JSON.stringify(login)).pipe(map(result => result));
}
logoutUser() {
  let accessToken = localStorage.getItem("accessToken");
  const url_api = 'http://localhost:50008/api/usuario/salir/'+accessToken;
  localStorage.removeItem("accessToken");
  localStorage.removeItem("codlector");
  return this.http.post(url_api, { headers: this.headers });
}
}
